import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import FJVerticalScroller from '../../common/components/FJScroller/FJVerticalScroller';
import FJDropDown from '../../common/components/FJDropDown/FJDropDown';
import styles from './FJDropList.module.less';
import classNames from 'classnames';
import ArrowIcon from '../../assets/svg/button-right.svg?react';
import CheckIcon from '../../assets/svg/choose.svg?react';

const FJDropList = props => {
    const { value, onChange, list = [], showCheckIcon = false, overlayWidth = 300 } = props;
    const dropDownRef = useRef(null);
    // const [overlayWidth, setOverlayWidth] = useState(0);
    const _handleRatioClick = item => {
        onChange(item);
        dropDownRef.current?.hide();
    };
    // useEffect(() => {
    //     if (dropDownRef.current && !overlayWidth) {
    //         setOverlayWidth(dropDownRef.current.triggerEle.current.offsetWidth);
    //     }
    // }, [overlayWidth]);
    const _overlay = (
        <FJVerticalScroller className={styles.drop_down_list_box}>
            {list.map(item => {
                return (
                    <div
                        className={classNames(styles.list_item, item.name === value.name && styles.list_item_active)}
                        key={item.name}
                        onClick={() => _handleRatioClick(item)}
                    >
                        {item.icon && <item.icon className={styles.list_item_icon} />}
                        <div className={styles.list_item_name}>{item.name}</div>
                        {showCheckIcon && item.name === value.name && (
                            <CheckIcon className={styles.list_item_check_icon} />
                        )}
                    </div>
                );
            })}
        </FJVerticalScroller>
    );
    return (
        <FJDropDown
            triggerDisplay='flex'
            placement='bottomLeft'
            isTopLayer={true}
            trigger='click'
            overlayStyle={{
                width: overlayWidth,
            }}
            ref={dropDownRef}
            overlay={_overlay}
        >
            <div className={styles.drop_down_box}>
                <div className={styles.drop_down_content}>
                    {value?.icon && <value.icon className={styles.drop_down_content_icon} />}
                    {value.name}
                </div>
                <ArrowIcon className={styles.drop_down_content_arrow} />
            </div>
        </FJDropDown>
    );
};
FJDropList.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    list: PropTypes.array,
    showCheckIcon: PropTypes.bool,
    overlayWidth: PropTypes.number,
};

export default FJDropList;
